import React from 'react'
import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'

import { jsonTryParse } from '@ztechapps/common.utils'

import type { TemplateTask } from './TaskTemplateValueInput/TaskTemplateStatusActionEditor'
import { StatusActionsBadge } from './TaskTemplateValueInput/TaskTemplateStatusActionEditor'
import { MembersBadge } from './TaskTemplateValueInput/TaskTemplateMembersEditor'

export const RowExtension = ({ value }: { value: string }) => {
  const tasks: TemplateTask[] = React.useMemo(() => jsonTryParse(value) ?? [], [value])

  return (
    <div className={'px-3'}>
      <b>Here are the tasks that will be added</b>

      <ul>
        {map(tasks, (task, index) => (
          <li key={index}>
            <span className="d-inline-flex align-items-center gap-2 align-middle">
              <span>{task?.name ?? ''}</span>
              {!isEmpty(task?.members) && <MembersBadge members={task.members} />}
              {!isEmpty(task?.statusActions) && <StatusActionsBadge count={task.statusActions.length} />}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
